// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1j-zv","spin":"Spinner_spin__KMS_F"};